'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Map, _handleActions;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _entity = require('conversations-core/reducers/utils/entity');

var _entity2 = _interopRequireDefault(_entity);

var _AgentTypes = require('conversations-schema/constants/AgentTypes');

var _Responder = require('conversations-schema/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)((_Map = {}, _defineProperty(_Map, _AgentTypes.HUMAN, (0, _immutable.Map)()), _defineProperty(_Map, _AgentTypes.BOT, (0, _immutable.Map)()), _Map));

exports.default = (0, _entity2.default)('responders', (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.GET_AGENT_SUCCEEDED, function (responders, action) {
  var _action$payload = action.payload,
      agent = _action$payload.agent,
      agentType = _action$payload.agentType;

  var userId = '' + agent.userId;

  return responders.setIn([agentType, userId], (0, _Responder2.default)(agent));
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_WIDGET_DATA_SUCCEEDED, function (responders, action) {
  var respondersFromWidgetData = action.payload.responders;


  var responderMap = respondersFromWidgetData.reduce(function (map, responder) {
    var agentType = responder.bot ? _AgentTypes.BOT : _AgentTypes.HUMAN;
    var userId = '' + responder.userId;

    return map.setIn([agentType, userId], responder);
  }, (0, _immutable.Map)());

  return responders.merge(responderMap);
}), _handleActions), initialState));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/responders.js
// module id = 515
// module chunks = 0